/* 82bfc1ad14fe68e8a3f03cca7346bb2e 8be804103de336ad3fcc3846dce28be6 c18ed1a5d1f4e2b4c4a51b5a18518fba
 */

let client_id = "";
let client_secret = "";
if (process.env.NODE_ENV === "development") {
    //开发环境
    client_id = "7BFSdvGdSYBQ583WoYHsMyfplTiq7NLMQGvOHRsa";
    client_secret = "N6yt7hSa1bWSVG29LaYjVQ8FNaUfVMqOcu6dSKKgRKE4yyVyHJbKLi3Nqf5tQPqQGeuZz6en9x9z7IZpNUn1kfKjwXw84xjepwVtwf15JlsBfIYVAbZdbX71VcjrRcvi";
}else{
    client_id = "7BFSdvGdSYBQ583WoYHsMyfplTiq7NLMQGvOHRsa";
    client_secret = "N6yt7hSa1bWSVG29LaYjVQ8FNaUfVMqOcu6dSKKgRKE4yyVyHJbKLi3Nqf5tQPqQGeuZz6en9x9z7IZpNUn1kfKjwXw84xjepwVtwf15JlsBfIYVAbZdbX71VcjrRcvi";
}

export {
    client_id,
    client_secret,
}